import {
  GET_OFFER_LIST,
  GET_OFFER_LIST_SUCCESS,
  GET_OFFER_LIST_FAILED,
  CLEAR_OFFER_MANAGEMENT_STATE,
  GET_OFFER_DETAIL_SUCCESS,
  GET_OFFER_DETAIL_FAILED,
  CANCEL_OFFER_DETAIL,
} from "../actions/offerManagement.action";

const INITIAL_STATE = {
  offerList: {
    data: [],
    total: 0,
    page: 1,
    status: "",
    search: "",
  },
  offerDetail: {},
  showDetailModal: false,
  error: {},
  loading: false,
};

export default function offerManagementReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_OFFER_LIST:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_OFFER_LIST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        offerList: payload,
      });
    case GET_OFFER_LIST_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    case CLEAR_OFFER_MANAGEMENT_STATE:
      return INITIAL_STATE;
    case GET_OFFER_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        offerDetail: payload,
        showDetailModal: true,
      });
    case GET_OFFER_DETAIL_FAILED:
      return Object.assign({}, state, {
        error: payload,
      });
    case CANCEL_OFFER_DETAIL:
      return Object.assign({}, state, {
        offerDetail: {},
        showDetailModal: false,
      });
    default:
      return state;
  }
}
